<template>
  <div class="width-100">
    <!-- :style="{ display: type != 'hidden' ? '' : 'none' }" -->
    <div class="p-inputgroup">
      <!-- <TreeSelect
        :name="name"
        :id="name"
        :options="options"
        :placeholder="placeholder"
        :modelValue="inputValue"
        :class="className"
        class="base"
      /> -->
      <TreeSelect
        :id="name"
        ref="ts"
        v-model="inputValue"
        :name="name"
        :options="items"
        :class="className"
        class="base"
        :placeholder="placeholder"
      >
        <template #footer="">
          <span
            v-if="addon"
            class="flex p-2 cursor ml-3 gap-3"
            @click="onBtnCreate"
          >
            <Icon type="favicon" :icon="'Folder'" class="Icon" />
            Add Folder
          </span>
        </template>
      </TreeSelect>
      <!-- <span class="p-inputgroup-addon" v-if="addon" @click="onBtnCreate">
        <i
          class="pi pi-plus cursor-pointer"
          v-tooltip.bottom="'Click here to edit'"
        ></i>
      </span> -->
      <!-- {{ inputValue }}---{{ modelValue }} -->
    </div>
  </div>
</template>
<script>
import { useField } from "vee-validate";
import {
  reactive,
  ref,
  watch,
  onMounted,
  inject,
  getCurrentInstance,
} from "vue";
import { getMyGemService } from "@/services";
import FolderService from "../../../services/folders.service";
import { DOMAIN } from "../../../services/domain-constant";
export default {
  props: {
    options: {
      type: [String, Array],
      default: "",
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    domain: {
      type: [String, Number],
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },

    className: {
      type: String,
      default: "",
    },

    name: {
      type: String,
      required: true,
    },
    addon: {
      type: Boolean,
      default: true,
    },
  },

  setup(props, { emit }) {
    // we don't provide any rules here because we are using form-level validation
    // https://vee-validate.logaretm.com/v4/guide/validation#form-level-validation
    const ts = ref(null);
    const items = ref([]);
    // get current instance
    const internalInstance = getCurrentInstance();
    // get the emitter from the instance
    const emitter = internalInstance.appContext.config.globalProperties.emitter;
    const service = new FolderService();
    const {
      value: inputValue,
      handleChange,
      meta,
      resetField,
    } = useField(props.name, undefined, {
      initialValue: String(props.modelValue),
    });
    resetField({
      value: String(props.modelValue),
    });
    watch(
      () => props.modelValue,
      (first) => {
        inputValue.value = first;
      }
    );

    function onBtnCreate() {
      ts.value.hide();
      emitter.emit("open-gem", {
        item: {
          key: "create",
          label: "Adding a Folder",
          isVisible: true,
          service: DOMAIN.FOLDERS,
          domain: props.domain,
          cb: (event) => {
            if (event.data.id) {
              const find = this.items.find(
                (value) => value.id == event.data.id
              );

              if (find != null) {
                find.display_name = event.data.display_name;
              } else {
                let tmpData = {
                  key: event.data.id,
                  icon: "pi pi-fw pi-folder",
                  label: event.data.display_name,
                };
                items.value.push(tmpData);

                // inputValue.value =
                // this.$refs.selection.inputValue = event.data.id;
                // this.selectedValue = event.data.id;
              }
            }
          },
        },
      });
      // emit("btn-create");
    }

    onMounted(() => {
      let data = { domain: props.domain, folderId: null };
      emitter.off(service.hookName("post"));
      emitter.on(service.hookName("post"), (event) => {
          if (event.meta["cb"]) {
            event.meta.cb(event);
          }
        });
      service.getHierarchy(data).then((data) => {
        items.value = data;
      });
    });
    return {
      handleChange,
      ts,
      inputValue,
      onBtnCreate,
      meta,
      items,
    };
  },
  data() {
    return {
      HTMLcontent: null,
    };
  },
  created() {
    this.HTMLcontent = `
    	<div>Create New</div>
`;
  },
};
</script>
